import { z } from 'zod';

/**
 * @see ConstantsService::DATA_PROVIDERS
 */
export enum DATA_PROVIDERS {
  GARMIN = 'garmin',
  OURA = 'oura',
  WITHINGS = 'withings',
  WHOOP = 'whoop',
  MANUAL = 'manual',
}

export const DataProviderSchema = z.nativeEnum(DATA_PROVIDERS).or(z.string());
export type TDataProvider = z.infer<typeof DataProviderSchema>;
